// Approved permanent team IDs. Burgundy board/frame are shared by Kaplan and Hamsi.
const LOOKS=[
 {id:'eagle',name:'Kartal',avatar:'avatar-eagle',board:'board-eagle',frame:'frame-eagle',colors:['#252c30','#f5f2e6']},
 {id:'lion',name:'Aslan',avatar:'avatar-lion',board:'board-lion',frame:'frame-lion',colors:['#922b36','#efc959']},
 {id:'canary',name:'Kanarya',avatar:'avatar-canary',board:'board-canary',frame:'frame-canary',colors:['#182e51','#f0cc4f']},
 {id:'tiger',name:'Kaplan',avatar:'avatar-tiger',board:'board-burgundy',frame:'frame-burgundy',colors:['#6b293d','#7bb6ce']},
 {id:'anchovy',name:'Hamsi',avatar:'avatar-anchovy',board:'board-burgundy',frame:'frame-burgundy',colors:['#6b293d','#7bb6ce']}
];
const PREVIEW_PRODUCTS=[];
module.exports={LOOKS,PREVIEW_PRODUCTS};
